import * as React from "react";

/** Filled arrow-back icon for 戻る back buttons. Default color: #767B7E (icon.default) */
export const IconArrowBack = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3337 7.33317H5.22033L8.94699 3.6065L8.00033 2.6665L2.66699 7.99984L8.00033 13.3332L8.94033 12.3932L5.22033 8.6665H13.3337V7.33317Z"
      fill="currentColor"
    />
  </svg>
);
